/**
 * Map/directory resume parks (browse / shops / favorites map), not checkout.
 * Hash is unused for map viewMode — path + `view=map` query is SSOT.
 */

function normalizeMapResumePath(pathWithQuery: string): string {
  const withoutHash = pathWithQuery.split('#', 1)[0] ?? pathWithQuery;
  const withoutQuery = withoutHash.split('?', 1)[0] ?? withoutHash;
  return withoutQuery.replace(/\/+$/, '') || '/';
}

function isAccountReturnPath(pathOnly: string): boolean {
  return (
    pathOnly === '/account' ||
    pathOnly.startsWith('/account/') ||
    /^\/[^/]+\/account(?:\/|$)/.test(pathOnly)
  );
}

/**
 * True for platform directory map hubs and tenant `/{tenant}/shops`.
 * False for kiosk `/{tenant}/shop`, account chrome, checkout/donate.
 */
export function isMapResumeReturnPath(pathWithQuery: string): boolean {
  if (typeof pathWithQuery !== 'string' || pathWithQuery.length === 0) {
    return false;
  }
  const pathOnly = normalizeMapResumePath(pathWithQuery);
  if (isAccountReturnPath(pathOnly)) {
    return false;
  }
  if (
    pathOnly === '/browse' ||
    pathOnly.startsWith('/browse/') ||
    pathOnly === '/shops' ||
    pathOnly.startsWith('/shops/') ||
    pathOnly === '/favorites' ||
    pathOnly.startsWith('/favorites/')
  ) {
    return true;
  }
  return /^\/[^/]+\/shops(?:\/|$)/.test(pathOnly);
}
